import { useEffect, useState, useCallback } from "react";
import { ButtonCopyStyled, ContentHashtagStyled } from "../../../../style-components";
import { ButtonCopyProps } from "./button-copy-type";
import CopyIcon from "@/assets/icons/papers/copy-icon";
import { useTheme } from "@/contexts/theme-context/useThemeContext";

const ButtonCopy: React.FC<ButtonCopyProps> = ({ 
  socialUserParticipant,
  hashtags, 
  template, 
  idExternal,
  isComingSoon,
  isConnect
}) => {

  const { theme } = useTheme();
  
  const [isCopyText, setIsCopyText] = useState<boolean>(false);
  const allHashtags = hashtags?.map((hashtag) => {
    return hashtag;
  }).join(' ');

  const existHashtags = allHashtags && allHashtags?.length > 0;

  const formatTemplate = (template: string, socialUserParticipant: string, idExternal: string) => {
    if (!template) return '';
  
    const urlRegex = /(https?:\/\/[^\s]+)/;

    const newTemplate = template.replace(urlRegex, (url) => {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}/${separator}reference_id=${idExternal}`;
    });

    return `${newTemplate} ${!socialUserParticipant ? idExternal : ''}`;
  };
  
  const handleCopy = useCallback(() => {
    if(isComingSoon || !isConnect) return;

    const formattedTemplate = formatTemplate(template ?? '', socialUserParticipant ?? '' ,idExternal ?? '');
    navigator.clipboard.writeText(`${formattedTemplate}`);
    setIsCopyText(true);
  }, [socialUserParticipant, template, idExternal, isComingSoon, isConnect]);

  useEffect(() => {
    if (!isCopyText) return;
    setTimeout(() => {
      setIsCopyText(false);
    }, 2000);
  }, [isCopyText]);

  return (
    <ContentHashtagStyled data-testid="box-button-copy"  onClick={handleCopy}>
      {isCopyText ? <span className="copy-text" style={{ width: '100%', textAlign: 'center', color: theme.colors.theme.success}}>¡Texto copiado al portapapeles!</span>:
      <>
        <p style={{ flex: 1 }}>
        {existHashtags && <span className="hashtag">{formatTemplate(template ?? '', socialUserParticipant ?? '', idExternal ?? '')}</span>}
        </p>
        <ButtonCopyStyled data-testid="button-copy" disabled={isComingSoon || !isConnect}>
          {!existHashtags && <span>Copiar</span>}<CopyIcon color={theme.colors.theme.brandColor3}/>
        </ButtonCopyStyled>
      </>}
    </ContentHashtagStyled>
  )
}

export default ButtonCopy;